module.exports = __webpack_public_path__ + "img/goods_share_green.fd2a96b4.svg";